const companyNumberPattern = /^(?:\d{8}|[A-Z]{2}\d{6})$/i;

export const companyNumberUrl = (companyNumber: string | null | undefined) => {
  if (companyNumber == null || !companyNumberPattern.test(companyNumber)) {
    return null;
  }

  return `https://find-and-update.company-information.service.gov.uk/company/${companyNumber}`;
};

export const signalLabels = (
  values: ReadonlyArray<string | null | undefined> | null | undefined,
  labelFor: (value: string) => string | null,
) =>
  values?.flatMap((value) => {
    if (value == null) {
      return [];
    }

    const label = labelFor(value);
    return label == null ? [] : [label];
  }) ?? [];

export const strengthLabel = (strength: string) => {
  switch (strength) {
    case 'STRONG_GOOGLE_REVIEWS':
      return 'Strong Google reviews';
    case 'PUBLISHES_MANAGEMENT_FEE':
      return 'Publishes management fees';
    case 'CLIENT_MONEY_PROTECTION_VERIFIED':
      return 'Client money protection verified';
    default:
      return null;
  }
};

export const considerationLabel = (consideration: string) => {
  switch (consideration) {
    case 'FEES_NOT_PUBLISHED':
      return 'Published fees were not available';
    case 'LIMITED_GOOGLE_REVIEWS':
      return 'Limited Google review history';
    case 'CLIENT_MONEY_PROTECTION_UNVERIFIED':
      return 'Client money protection still needs checking';
    default:
      return null;
  }
};

export const portalLabel = (portal: string | null | undefined) => {
  switch (portal) {
    case 'RIGHTMOVE':
      return 'Rightmove';
    case 'ZOOPLA':
      return 'Zoopla';
    case 'ON_THE_MARKET':
      return 'OnTheMarket';
    default:
      return 'Portal';
  }
};

export const formatRating = (
  rating: number | null | undefined,
  reviewCount: number | null | undefined,
) => {
  if (rating == null) {
    return 'Not found';
  }

  return `${rating.toFixed(1)} · ${reviewCount ?? 0} reviews`;
};

export const formatRedressScheme = (scheme: string | null | undefined) => {
  if (!scheme) {
    return 'Not verified';
  }

  return scheme === 'PROPERTY_REDRESS_SCHEME'
    ? 'Property Redress Scheme'
    : 'The Property Ombudsman';
};

export const formatClientMoneyProtection = (
  hasClientMoneyProtection: boolean | null | undefined,
) => {
  if (hasClientMoneyProtection == null) {
    return 'Not verified';
  }

  return hasClientMoneyProtection ? 'Found' : 'Not found';
};
